<template>
    <div class="pointer h30" @click="openSw" >
        <div v-if="active"><img style="width: 40px;" src="@/assets/images/kaiguankai.png"/></div>
        <div v-if="!active"><img  style="width: 40px;" src="@/assets/images/kaiguanguan.png"/></div>
    </div>
  </template>
   
  <script>

  
  export default {
      name: 'MySwitch',
      props: {
          value:{},
          open: {},
      },
      model: {
          prop: "value",
          event: "change"
      },
      watch:{
            value:{
                handler(newValue) {
                    console.log("newValue", newValue);
                    this.active = newValue == 1;
                },
                immediate: true,
                deep: true   //深度监听                
            } 
      },

      data() {
          return {
            active: false,
          }
      },
      methods: {
        
        openSw() {
            this.active = !this.active;            
            this.$emit("change", this.active ? 1 : 0);
        }
      }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/switch/Switch.vue